module.exports = __webpack_public_path__ + "uarm-images/letter-a-text-variant.svg";